/** Formats a reconnect delay for status logs (ms when under 1s, seconds otherwise). */
export function formatReconnectDelayForLog(delayMs: number): string {
  if (delayMs < 1000) return `${delayMs}ms`;
  const s = delayMs / 1000;
  return Number.isInteger(s) ? `${s}s` : `${s.toFixed(1)}s`;
}
